import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { prop } from 'ramda';

import {
  getBrand,
  getLocations as getBrandLocations,
  getLocationsError,
  fetchLocations
} from 'redux/modules/brand';

import { getLocations as getHugggLocations } from 'redux/modules/huggg';

export class WithLocations extends Component {
  componentDidMount() {
    const { apiError, brandId, fetchLocations, locations } = this.props;

    if (!locations.length && !apiError) {
      fetchLocations(brandId);
    }
  }

  render() {
    const { component: WrappedComponent, locations, ...rest } = this.props;

    return <WrappedComponent locations={locations} {...rest} />;
  }
}

WithLocations.propTypes = {
  brandId: PropTypes.string.isRequired,
  component: PropTypes.any.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  apiError: PropTypes.string,
  locations: PropTypes.array
};

export default WrappedComponent => {
  const mapStateToProps = state => {
    const locations = getHugggLocations(state);

    return {
      locations: locations.length ? locations : getBrandLocations(state),
      brandId: prop('id', getBrand(state)),
      apiError: getLocationsError(state),
      component: WrappedComponent
    };
  };

  return withRouter(
    connect(mapStateToProps, { fetchLocations })(WithLocations)
  );
};
